import processShim from 'process/browser';
import { Buffer } from 'buffer';

type NextTick = (callback: (...args: any[]) => void, ...args: any[]) => void;

type ProcessVersionsLike = Partial<NodeJS.ProcessVersions> &
  Record<string, string>;

type ProcessLike = {
  nextTick?: NextTick;
  browser?: boolean;
  version?: string;
  versions?: ProcessVersionsLike;
  env?: Record<string, unknown>;
};

const globalRef = globalThis as {
  process?: unknown;
  Buffer?: typeof Buffer;
};

const getProcessRef = (): ProcessLike => {
  const existingProcess = globalRef.process;

  if (!existingProcess) {
    globalRef.process = processShim as unknown as ProcessLike;
    return globalRef.process as ProcessLike;
  }

  return existingProcess as ProcessLike;
};

const processRef = getProcessRef();

Object.assign(processRef, processShim);

if (typeof processRef.nextTick !== 'function') {
  processRef.nextTick = ((callback: (...args: any[]) => void, ...args: any[]) => {
    Promise.resolve().then(() => callback(...args));
  }) as NextTick;
}

if (!processRef.version) {
  processRef.version = 'v20.0.0';
}

if (!processRef.versions) {
  processRef.versions = { node: '20.0.0' } as ProcessVersionsLike;
} else if (!processRef.versions.node) {
  processRef.versions.node = '20.0.0';
}

if (processRef.browser !== true) {
  processRef.browser = true;
}

if (!globalRef.Buffer) {
  globalRef.Buffer = Buffer;
}
